import {Grid, Link, Pillar, Section, SectionIntro} from '@primer/react-brand'
import {Spacer, SectionVisual} from './_shared'

export default function CustomerStories() {
  return (
    <Section id="customer-stories">
      <SectionVisual visual="duck" />

      <SectionIntro align="center" fullWidth>
        <SectionIntro.Heading as="h2" size="4">
          <em>From startups to enterprises,</em> GitHub scales <br className="lp-breakText" /> with teams of any size in
          any industry.
        </SectionIntro.Heading>
      </SectionIntro>

      <Spacer size="32px" size1012="56px" />

      {/*
        TODO:
        - Move to data file
        - Add all stories
        - Add filter toggle
      */}
      <Grid className="lp-CustomerStories-grid">
        <Grid.Column className="lp-CustomerStories-gridColumn" span={{xsmall: 12, medium: 6, large: 4}}>
          <Pillar className="lp-CustomerStories-pillar">
            <Pillar.Icon
              className="lp-CustomerStories-logo"
              icon={
                <img
                  src="/images/modules/site/home24/customer-stories/duolingo.svg"
                  alt="Duolingo's logo"
                  height="50"
                />
              }
            />
            <Pillar.Heading className="lp-CustomerStories-heading" size="subhead-medium">
              Technology
            </Pillar.Heading>
            <Pillar.Description className="lp-CustomerStories-description">
              Duolingo boosts developer speed by 25% with Copilot
            </Pillar.Description>
          </Pillar>
        </Grid.Column>

        <Grid.Column className="lp-CustomerStories-gridColumn" span={{xsmall: 12, medium: 6, large: 4}}>
          <Pillar className="lp-CustomerStories-pillar">
            <Pillar.Icon
              className="lp-CustomerStories-logo"
              icon={
                <img
                  src="/images/modules/site/home24/customer-stories/mercedes.svg"
                  alt="Mercedez Benz's logo"
                  height="42"
                />
              }
            />
            <Pillar.Heading className="lp-CustomerStories-heading" size="subhead-medium">
              Automotive
            </Pillar.Heading>
            <Pillar.Description className="lp-CustomerStories-description">
              Mercedez-Benz standardizes source code and automates onboarding
            </Pillar.Description>
          </Pillar>
        </Grid.Column>

        <Grid.Column className="lp-CustomerStories-gridColumn" span={{xsmall: 12, medium: 6, large: 4}}>
          <Pillar className="lp-CustomerStories-pillar">
            <Pillar.Icon
              className="lp-CustomerStories-logo"
              icon={
                <img
                  src="/images/modules/site/home24/customer-stories/mercado-libre.svg"
                  alt="Mercado Libre's logo"
                  height="37"
                />
              }
            />
            <Pillar.Heading className="lp-CustomerStories-heading" size="subhead-medium">
              Financial services
            </Pillar.Heading>
            <Pillar.Description className="lp-CustomerStories-description">
              Mercado Libre cuts coding time by 50%
            </Pillar.Description>
          </Pillar>
        </Grid.Column>
      </Grid>

      <Spacer size="32px" size1012="48px" />

      {/* Links */}
      <div className="lp-CustomerStories-links">
        <Link className="lp-CustomerStories-link" href="#TODO">
          Explore customer stories
        </Link>

        <hr className="lp-CustomerStories-divider" />

        <Link className="lp-CustomerStories-link" href="#TODO">
          Explore all solutions
        </Link>
      </div>
    </Section>
  )
}

try{ CustomerStories.displayName ||= 'CustomerStories' } catch {}